var map = {
	"./logo-agoric.webp": 11570,
	"./logo-aib.webp": 40353,
	"./logo-alter.webp": 81341,
	"./logo-andromeda.webp": 20806,
	"./logo-architech.webp": 8114,
	"./logo-archway.webp": 7570,
	"./logo-axelar.webp": 98260,
	"./logo-bitcanna.webp": 6465,
	"./logo-bonus-block.webp": 87114,
	"./logo-crypto-chemistry.webp": 4441,
	"./logo-cudos.webp": 11739,
	"./logo-decentr.webp": 65692,
	"./logo-empowerchain.webp": 13963,
	"./logo-gravity-bridge.webp": 71771,
	"./logo-inter-protocol.webp": 91854,
	"./logo-jackal.webp": 85061,
	"./logo-kado.webp": 35698,
	"./logo-kelepar.webp": 89343,
	"./logo-kusama-kingdom.webp": 79841,
	"./logo-landslide.webp": 25019,
	"./logo-liquid-finance.webp": 75044,
	"./logo-living-opera.webp": 60364,
	"./logo-luckyfriday.webp": 55902,
	"./logo-nibiru.webp": 21750,
	"./logo-phi-labs.webp": 90069,
	"./logo-qwoyn-studios.webp": 41189,
	"./logo-silvermine-capital.webp": 33124,
	"./logo-sky-consulting.webp": 26379,
	"./logo-synaps.webp": 65623,
	"./logo-vidulum.webp": 28169,
	"./logo-xavier-capital.webp": 91491
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5625;